import { createControlComponent } from "@react-leaflet/core";
import "esri-leaflet";
import * as EL from "esri-leaflet";
import * as ELG from "esri-leaflet-geocoder";
import "esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css";
import { KeyboardEvent, useEffect, useRef } from "react";

const createGeoSearch = (props: any) => {
  const { providers: providersProp } = props;

  const providers = Object.keys(providersProp).map((provider) => {
    if (Object.keys(providersProp[provider]).length > 0) {
      return ELG[provider](providersProp[provider]);
    } else {
      return ELG[provider]();
    }
  });

  const searchOptions = {
    ...props,
    providers
  };

  // @ts-ignore
  const geoSearch = new ELG.Geosearch(searchOptions);

  if (props.eventHandlers) {
    const events = Object.keys(props.eventHandlers);
    events.forEach((event) => {
      geoSearch.on(event, props.eventHandlers[event]);
    });
  }

  return geoSearch;
};

/**
 * EsriLeaflet GeoSearch control component, react-leaflet wrapper for
 * [L.esri.Geocoding.Geosearch](https://developers.arcgis.com/esri-leaflet/api-reference/controls/geosearch/).
 *
 * For more info: https://github.com/slutske22/react-esri-leaflet#esrileafletgeosearch
 */
const EsriLeafletGeoSearch = createControlComponent<
  //@ts-ignore
  EL.Geocoding.GeosearchControl,
  //@ts-ignore
  // eslint-disable-next-line no-undef
  Props
>(createGeoSearch);

const EsriLeafletGeoSearchWithFocus = (props: any) => {
  const searchRef = useRef<any>(null);

  useEffect(() => {
    const handleKeyDown: any = (event: KeyboardEvent) => {
      if (event.altKey && event.shiftKey && event.code === "KeyS") {
        event.preventDefault();
        if (searchRef.current) {
          const searchInput = document.querySelector(
            ".geocoder-control-input"
          ) as HTMLInputElement;
          searchInput.focus();
          if (searchInput) {
            searchInput.click();
            searchInput.focus();
          }
        }
      } else if (event.key === "Escape") {
        const searchInput = document.querySelector(
          ".geocoder-control-input"
        ) as HTMLInputElement;
        if (searchInput) {
          searchInput.blur();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return <EsriLeafletGeoSearch ref={searchRef} {...props} />;
};

export default EsriLeafletGeoSearchWithFocus;
